import React from 'react';
import Styles from './lesson-styles.scss';
import classNames from 'classnames';
import { CircleNextButton, CirclePlayButton, ProgressBarSimple } from '@/presentation/components';
const Lesson = ({ module, onClick, logo: Logo, inactiveButton = false }) => {
    return (React.createElement("div", { className: classNames([Styles.lessonWrap]) },
        React.createElement("div", { className: Styles.score },
            React.createElement("div", { className: Styles.scoreContent },
                React.createElement("div", { className: Styles.logo }, Logo && React.createElement(Logo, null)))),
        React.createElement("div", { className: Styles.title }, module.title),
        React.createElement("div", { className: Styles.content },
            React.createElement("div", { className: Styles.progressContainer },
                React.createElement("div", { className: Styles.bar },
                    React.createElement(ProgressBarSimple, { percentage: module.progress, backgroundColor: "green", leftText: "Progress", rightText: `${module.progress}%` })),
                React.createElement("div", { className: Styles.icon }, inactiveButton ? (React.createElement(CirclePlayButton, { background: "gray" })) : module.progress === 100 ? (React.createElement(CircleNextButton, { background: "lightBlue", onClick: onClick })) : (React.createElement(CirclePlayButton, { background: "blue", onClick: onClick })))))));
};
export default Lesson;
